import React from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
import Icons from "../../../../Components/Icons/Icons";
import Modal from "react-bootstrap/Modal";
import Inputs from '../../../../Components/Inputs/Inputs';
import {getUserInfo} from '../../../../Utils/UserFunctions';

const subFolderPopup = (props) => {
    //console.log(JSON.parse(props.formFolderFields), 'props.formFolderFields');
    //console.log(getUserInfo(), 'getUserInfo')
    const curProfileID = getUserInfo().data.profile_id;
    const fieldDetail = JSON.parse(props.formFolderFields);
    
    return(
        <Wrp>
            <Modal dialogClassName="modal-dialog modal-dialog modal-sm height-auto" show={props.isModalSubFolderPopup} onHide={props.toggleSubFolderPopup}>
              <Modal.Header>
                <h5 className="modal-title secondary_color pl-2 mb-0">Create New Folder</h5> 
              </Modal.Header>
              <Modal.Body>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label><b> Folder Name </b></label>                                            
                        <Inputs fieldName="folder_name" formData={JSON.stringify(fieldDetail.folder_name)} changed={props.addDataHandlerFolder}/> 
                        {fieldDetail.folder_name.error !== "" ? 
                            <label className="error m-0">{fieldDetail.folder_name.error}</label>
                            : null
                        }
                      </div>
                    </div>
                  </div>

              </Modal.Body>

              <Modal.Footer>
                  <a href="#" className="btn btn-cancel mr-2" data-dismiss="modal" onClick={props.toggleSubFolderPopup}> Cancel </a> 
                  <a href="#" className="btn primary_bg" onClick={props.addSubFolderHandler}>Add</a>                
              </Modal.Footer>
            </Modal>

            
        </Wrp>
    )
}

export default subFolderPopup;